import AccessTimeIcon from "@mui/icons-material/AccessTime";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { Box, ListItem, ListItemText, Typography } from "@mui/material";
import { formatTime, HHNTheme } from "hhn-commons";
import { RouteChip } from "../Calendar.style";
import theme from "../../theme";
import { PatientHeaderDescription } from "../../message/messageHeader/patientGroupHeader/PatientHeaderDescription";
import { GROUP_AVATAR_SIZE } from "../../utils/AvatarUtils";

function LocationInfo(props: {
  onClick: () => void;
  index: any;
  location: any;
  isSelected?: boolean;
}) {
  return (
    <ListItem
      sx={{
        py: 2,
        flexDirection: "column",
        alignItems: "flex-start",
        cursor: "pointer",
      }}
      onClick={props.onClick}
    >
      <RouteChip
        label={`Stop ${props.index + 1}`}
        markerColor={
          props.isSelected ? theme.palette.primary.main : HHNTheme.route.stop
        }
        size="small"
        icon={<LocationOnIcon />}
      />
      <ListItemText
        primary={
          <PatientHeaderDescription
            patientStatus={props.location.patientStatus}
            name={props.location.name}
            servicesToPatient={[]}
            fontSizeTitle={16}
            avatarSize={GROUP_AVATAR_SIZE.XSMALL}
          />
        }
        secondary={
          <Box
            sx={{
              display: "flex",
              mt: 0.5,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                mr: 2,
              }}
            >
              <AccessTimeIcon
                fontSize="small"
                color="action"
                sx={{ mr: 0.5 }}
              />
              <Typography variant="body2" color="textSecondary">
                {formatTime(props.location.schedulerTime)} -{" "}
                {formatTime(props.location.schedulerEndTime)}
              </Typography>
            </Box>
          </Box>
        }
      />
    </ListItem>
  );
}

export default LocationInfo;
